import { useEffect, useMemo, useState } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "next-themes";

import { SiteLayout } from "@/components/SiteLayout";
import { Toaster } from "@/components/ui/sonner";
import { siteContent } from "@/data/siteContent";
import AboutPage from "@/pages/AboutPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ContactPage from "@/pages/ContactPage";
import HomePage from "@/pages/HomePage";
import ProcessPage from "@/pages/ProcessPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import ProductsPage from "@/pages/ProductsPage";
import WholesalePage from "@/pages/WholesalePage";
import { SeoManager } from "@/components/SeoManager";

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return null;
}

function AppShell() {
  const [language, setLanguage] = useState("en");
  const content = useMemo(() => siteContent[language], [language]);

  return (
    <SiteLayout content={content} language={language} onLanguageChange={setLanguage}>
      <SeoManager content={content} />
      <Routes>
        <Route path="/" element={<HomePage content={content} />} />
        <Route path="/products" element={<ProductsPage content={content} />} />
        <Route path="/products/:slug" element={<ProductDetailPage content={content} />} />
        <Route path="/wholesale" element={<WholesalePage content={content} />} />
        <Route path="/about" element={<AboutPage content={content} />} />
        <Route path="/process" element={<ProcessPage content={content} />} />
        <Route path="/blog" element={<BlogPage content={content} />} />
        <Route path="/blog/:slug" element={<BlogPostPage content={content} />} />
        <Route path="/contact" element={<ContactPage content={content} />} />
      </Routes>
    </SiteLayout>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider attribute="class" forcedTheme="light">
        <BrowserRouter>
          <ScrollToTop />
          <AppShell />
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </ThemeProvider>
    </div>
  );
}

export default App;
